<div class="content">
  <div class="card">
    <wex-progress-bar *ngIf="progressVisible"></wex-progress-bar>
    <div class="card-content">
      <router-outlet></router-outlet>
    </div>
    <wex-navigation *ngIf="navigationVisible"></wex-navigation>
  </div>
</div>
